import React from 'react';
import PropTypes from 'prop-types';

const StakeholdersSection = ({ stakeholders }) => {
  return (
    <section className="py-6 md:py-10 lg:py-14">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-bold mb-4 md:mb-6">
            <span className="">Built for Every </span><span className="secondary-text">Stakeholder</span>
          </h2>
          <p className="    max-w-4xl mx-auto">
            Empowering personalized, connected, and data-driven healthcare for better outcomes.
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 max-w-4xl mx-auto">
          {stakeholders.map((stakeholder, index) => (
            <div
              key={index}
              className="group relative rounded-lg overflow-hidden shadow-xl h-64 md:h-72 cursor-pointer transition-all duration-300"
            >
              {/* Background Image */}
              <div className="absolute inset-0">
                <img
                  src={stakeholder.image}
                  alt={stakeholder.title}
                  className="w-full h-full object-cover scale-110"
                />
              </div>

              {/* Dark Blue Overlay + Content (Default State - Visible) */}
              <div className="absolute inset-0 primary-bg opacity-90 group-hover:opacity-0 transition-opacity duration-300">
                <div className="h-full flex flex-col justify-end p-6 md:p-8 pb-8 text-white">
                  {/* Title with half underline (from middle) */}
                  <div className="mb-3">
                    <h3 className="  font-bold">
                      {stakeholder.title}
                    </h3>
                    <div className="w-1/2 h-0.5 bg-white"></div>
                  </div>

                  {/* Features List */}
                  <ul>
                    {stakeholder.features.map((feature, idx) => (
                      <li key={idx} className="text-xs md: flex items-start leading-relaxed">
                        <span className="mr-2 flex-shrink-0">&gt;</span>
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* Hover State - Only Image Visible (overlay fades out) */}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

StakeholdersSection.propTypes = {
  stakeholders: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      features: PropTypes.arrayOf(PropTypes.string).isRequired,
    })
  ).isRequired,
};

export default StakeholdersSection;